<template>
  <!-- <div @click="handleClick">{{message}}</div> -->
  <div class="box">
    <div  class="denglu login-code" v-show="showPanel=='code'" ref="codeDialog">
        <img class="img1" src="../../assets/img/logo.png" alt />
        <span class="span2">谱恒高科技能源管理系统</span>

        <div class="switch-bg" @click="switchLogin('user')"></div>
        <div class="switchBtn" data-type="qrcode"><i class="iconfont icon-switch" @click="switchLogin('user')">&#xe601;</i></div>
        <!-- <div class="title">谱恒高科技有限责任公司</div> -->
        <div class="qrcode" id="qrcode"></div>
        <div>用微信扫码关注公众号直接登录</div>
    </div>

    <div class="denglu login-user" v-show="showPanel=='user'" @keyup.enter="submitForm('ruleForm')" ref="userDialog">
      <img class="img1" src="../../assets/img/logo.png" alt />
      <span class="span2">谱恒高科技能源管理系统</span>

      <div class="switch-bg"  @click="switchLogin('code')"></div>
      <div class="switchBtn" data-type="user"><i class="iconfont icon-switch" @click="switchLogin('code')">&#xe61a;</i></div>
      <el-form :model="userinfo" class="eleform" :rules="rules" ref="ruleForm">
        <el-form-item label="账号" prop="userName">
          <el-input placeholder="请输入账号" v-model="userinfo.userName" class="input" ref="userinput"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            :type="passwordindex"
            placeholder="请输入密码"
            v-model="userinfo.password"
            class="input"
          ></el-input>
          <img
            class="eye"
            :src="passwordindex === 'password'?eyeurl01:eyeurl02"
            alt
            @click.stop="changeindex"
          />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input placeholder="请输入验证码" v-model="userinfo.code" class="wid" :clearable="true"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" class="btn">登录</el-button>
        </el-form-item>
      </el-form>
      <img class="codeimg" :src="codeurl" alt @click="changcodeimg" />
      <!-- <el-checkbox v-model="ismemorypassword" class="ismemory">记住密码</el-checkbox> -->
    </div>
  </div>
</template>

<script>
import http from "@/utils/request"
import QRCode from "qrcodejs2"
import { getListDb,testDb,setUserFreeSettings,checkloginByToken} from '@api/common';

export default {
  name: "login",
  data() {
    //输入框不为空的检验方法
    var userName = (rule, value, callback) => {
      if (!value.trim()) {
        return callback(new Error("不能为空!"));
      } else {
        callback();
      }
    };
    return {
      codeurl: process.env.VUE_APP_APIURL+`/user/captcha?_=${new Date().getTime()}`,
      // codeurl: `http://localhost/user/captcha?_=${new Date().getTime()}`,
      eyeurl01: require("../../assets/img/eyebi.png"),
      eyeurl02: require("../../assets/img/eyezheng.png"),
      passwordindex: "password",
      userinfo: {
        userName: "",
        password: "",
        code: "",
      },
      ismemorypassword: false,

      rules: {
        userName: [{ validator: userName, trigger: "blur" }],
        password: [{ validator: userName, trigger: "blur" }],
        code: [{ validator: userName, trigger: "blur" }],
      },
      timeId:null , // 定时任务
      showPanel:"code", // 显示的登录框
      tempcode:"" , // 临时码

      selectedDb:null, // 选择的数据库
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //从localstorage中提取是否有记住的账户密码信息
    if(localStorage.getItem('userinfo')){
      let userinfo = JSON.parse(localStorage.getItem('userinfo'));
      this.userinfo.userName = userinfo.userName;
      this.userinfo.password = userinfo.password;
      this.ismemorypassword = true;
    }
  },
  watch:{
    showPanel:function (newValue) {
      if(newValue=="code"){
        this.creatQrcode();// 创建二维码
      }else{
        // 停止侦听器
        if(this.timeId){
          clearTimeout(this.timeId);
        }
      }
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted(){
    // 判断是否已经登录
    this.checkLogin();
  },
  //方法集合
  methods: {
    // 检查是否登录
    checkLogin(){
      let token=this.getQueryString("token")||sessionStorage.getItem("token")||"";
      // 当不存在token的时候，不进行登录检查
      if(token){
        checkloginByToken(token).then(res=>{
            if(res&&res.status==200){
              let token=res.content.token;
              this.$store.commit("token",token);
              // 获取用户信息
              this.$store.commit("user",res.content);
              // 执行登录
              this.loginJump();
            }else{
              // 生成二维码
              this.creatQrcode();
            }
        });
      }else{
        // 生成二维码
        this.creatQrcode();
      }
      
    },
    //改变密码的可视状态
    changeindex() {
      if (this.passwordindex === "password") {
        this.passwordindex = "text";
      } else {
        this.passwordindex = "password";
      }
    },
    //点击切换验证码
    changcodeimg() {
      this.codeurl = process.env.VUE_APP_APIURL+`/user/captcha?_=${new Date().getTime()}`;
    },
    //点击登录发起请求
    submitForm(formName) {
      // var _this = this;
      this.$refs[formName].validate(valid => {
        
        if (valid) {
          let pwd=this.userinfo.password.trim();
          let rsa_n = 'D42E861C04CFB9EBB1368A682EC22BDCA364A35E1C5DF1D43FC4F24197D4B798BCB7FD0192774749C4DED8B659002B4ABEA2F11F7896BCEE5CD615D31EF8936823ED6760CA01D91F677F1459019383679D78BE72FE67E7C1C3FDA1A514B5FE35879A9A9DC90EAE059948CD222F4C69F37F23F0864112CD4A8AE2B4FD9EC36297';
          /* eslint-disable */
          setMaxDigits(131); //131 => n的十六进制位数/2+3
          let key  = new RSAKeyPair("10001", '', rsa_n); //10001 => e的十六进制

          // 如果不是使用临时密码登录的，则将密码进行加密处理
          let UserPwd = pwd;
          if(pwd.length<20){
            UserPwd = encryptedString(key, pwd+'\x01'); //不支持汉字
          }
          let data = {
            username: this.userinfo.userName.trim(),
            password: UserPwd,
            vercode: this.userinfo.code.trim()
          };

          http({
            url:"/user/login"
            ,method:"post"
            ,data:data
          }).then(res=>{
            if(res.status!=200){
              // 刷新验证码
              this.changcodeimg();
            }
            // store中设置token请求信息
            if(res.status==200){
              let token=res.content.token;
              this.$store.commit("token",token);
              // 获取用户信息
              this.$store.commit("user",res.content);

              // 执行登录
              this.loginJump();
            }
        });
        }
      });
    }

    // 生成二维码
    ,creatQrcode(){
      if(this.showPanel=='code'){
        var canvas = document.getElementById('qrcode');

        let that=this;
        
        //当div下还存在子节点时 循环继续
        while(canvas.hasChildNodes()){
          canvas.removeChild(canvas.firstChild); 
        }
  
        // 修改临时码
        that.tempcode=new Date().getTime();
        var qrcode = new QRCode(canvas, {
            text: process.env.VUE_APP_WXCODE+"?tempcode="+that.tempcode,
            width:200,
            height:200,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
        });
        // 检查登录状态
        // 定时调用获取登录状态
        that.timeId=setTimeout(that.checkloginByCode(that.tempcode),2000);
      }else{
        if(this.timeId){
          clearTimeout(this.timeId);
        }
      }
    },
    // 验证微信是否登录
    checkloginByCode(randomId){
      let that=this;
      if(that.showPanel=="code"&&location.href.indexOf("login")>=0){
        that.timeId=setTimeout(function(){

          if(that.timeId){
            // 清空定时器
            clearTimeout(that.timeId);
          }
          // 发起检查操作
          var url="/user/checkloginByCode"
          http({
              url:url,
              method:"POST",
              data:{
                tempcode:that.tempcode
              }
          }).then(res=>{
            if(res&&res.status&&res.status==200){
              // 页面跳转
              let token=res.content.token;
              that.$store.commit("token",token);

              // 获取用户信息
              that.$store.commit("user",res.content);
              // 执行登录
              that.loginJump();
              
            }else{
              that.checkloginByCode(that.tempcode);
            }
          }).catch(()=>{
            // 出现异常错误的时候同样进行再次检查
            that.checkloginByCode(that.tempcode);
          })
        },2000);
      }else{
        if(that.timeId){
            // 清空定时器
            clearTimeout(that.timeId);
          }
      }
    },
    loginJump(){
      let that=this;
      // 跳转到新的页面
      that.$nextTick(()=>{
        // 判断是否有dbname参数，进行直接登录
        let dbname=that.getQueryString("dbname");
        if(dbname){
          that.getDbList();
        }else{
          // 跳转到新的页面
          that.$router.push("/changeFactory"+window.location.search);
        }
      })
    },
    // 登录方式切换
    switchLogin(item){
      switch(item){
        case "code":
          this.showPanel="code";
          break;
        case "user":
          this.showPanel="user";
          // div获取焦点
          this.$nextTick(function(){
              // this.$refs.userinput.focus();        
          })
          break;
      }
    },
    // 选择数据库
    async selectDbBtn(){
      if(this.selectedDb){
        let dbStatus=await testDb(this.selectedDb.dburlname); // 测试数据库是否可用
        if(dbStatus.status == 200){
          // 更新数据库信息
          this.$store.commit('db',this.selectedDb);
          // 同步获取用户配置信息和站点信息,并更新vuex里面的内容 
          this.$store.dispatch("getUserConfig").then(()=>{
            let page=this.getQueryString("page");
            if(!page){
              page="realTimeForm";
            }
            this.$router.push({name:page});
          });
          // 保存用户选择的数据库
          let config=this.userConfig||{};
          config.defaultDb=this.selectedDb;
          // 远程保存用户配置
          setUserFreeSettings(JSON.stringify(config));
        }else{
          this.$message({
            showClose: true,
            message: '数据库不可用',
            type: 'error'
          });
        }
      }else{
         this.$message({
            showClose: true,
            message: '请选择数据库',
            type: 'warning'
          });
      }
    },
    /* 首次进入页面获取数据 */
    async getDbList(){
      let data =  await getListDb();
      let dbList=data.content;
      // 判断是否url中是否有数据库参数,如果有相关的参数，直接进入相应的数据库
      let dbname=this.getQueryString("dbname");
      if(dbname){
        for(let group of dbList){
          let databasesList=group.databasesList;
          for(let db of databasesList){
            let dburlname=db.dburlname;
            if(dbname==dburlname){
              this.selectedDb=db;
              this.selectDbBtn();
            }
          }
        }
        // 没有相应的权限
        if(!this.selectedDb){
          this.$message({
            message:"您无权访问该数据库",
            type:"error",
          })
        }
      }
    },
    // 查询url参数
    getQueryString(name){
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
          return decodeURIComponent(r[2]);
      }
      return null;
    }
  },
  
};
</script>

<style lang="scss" scope>
.box {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: url("../../assets/img/loginbac.jpg") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .denglu {
    width: 430px;
    height: 308px;
    box-sizing: border-box;
    border-radius: 30px;
    padding: 40px;
    background-color: white;
    // border: 1px solid black;
    position: relative;

    .img1 {
      width: 79px;
      height: 69px;
      position: absolute;
      top: -120px;
      left: 160px;
    }
    .span2 {
      font-size: 25px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      position: absolute;
      top: -40px;
      left: 69px;
    }
    .eye {
      width: 19px;
      position: absolute;
      top: 10px;
      right: 36px;
      cursor: pointer;
    }
    .eleform .el-form-item__label {
      text-align: center;
      width: 60px;
    }
    .eleform .el-form-item__error {
      position: absolute;
      top: 100%;
      left: 58px;
    }
    .p1 {
      text-align: center;
      line-height: 20px;
    }
    .eleform {
      width: 100%;
    }
    .wid {
      width: 180px;
      height: 36px;
    }
    .input {
      width: 260px;
      height: 36px;
      border-radius: 4px;
    }
    .codeimg {
      width: 77px;
      height: 35px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      background: white;
      position: absolute;
      top: 165px;
      right: 70px;
      cursor: pointer;
    }
    .ismemory{
      position: absolute;
      bottom: 80px;
      right: 67px;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #333333;
    }

    .btn {
      width: 260px;
      height: 36px;
      background: rgba(89, 143, 255, 1);
      border-radius: 4px;
      margin: 10px 0 0 0;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  /*扫码登录*/
  .switchBtn{
      position: absolute;
      right: 0;
      top: 0px;
      border-top-right-radius: 30px;
      text-align: center;
      cursor: pointer;
      color: #fff;

      i{
        font-size: 25px;
      }
  }
  .switch-bg{
      position: absolute;
      right: 0;
      text-align: right;
      font-size: 28px;
      color: white;
      width: 0;
      height: 0;
      border-top: 50px solid #aaa;
      border-left: 50px solid transparent;
      top: 0;
  }
  .login-code{
    text-align: center;
    // display: block;
  }

  // .login-user{
  //     display: none;
  // }
  .qrcode{
      display: inline-block;
      padding:10px 10px 0 10px;
  }
}
</style>